export default "__VITE_ASSET__44cae66b__"